import { propClassName } from '@/styles/SavedArticles';
import { cn } from 'lib/utils/cn';
import type { ClassNameProp, Component, ComponentProps } from 'types/component';

export interface SavedArticlesArticleDescriptionProps extends ComponentProps<'p'> {
  variant?: ClassNameProp<'default'>;
  colors?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
}

export const SavedArticlesArticleDescriptionComponent: Component<SavedArticlesArticleDescriptionProps> = ({
  className,
  variant,
  colors,
  size,
  children,
  ...props
}) => {
  const variantClassName = propClassName('article_description_variant', variant, 'default');
  const colorsClassName = propClassName('article_description_colors', colors, 'default');
  const sizeClassName = propClassName('article_description_size', size, 'default');
  const componentClassName = cn(variantClassName, colorsClassName, sizeClassName, className);

  return (
    <p className={componentClassName} {...props}>
      {children}
    </p>
  );
};
